import { type FC, useContext } from 'react';

import { specContractRequirenments } from '@/common/config/contract';
import { specContractModalsName } from '@/common/constants/contract';
import {
  type ContractType,
  type SpecContractType,
} from '@/common/types/contract';
import { SpecContractItem } from '@/components/Contract/SpecContractItem/SpecContractItem';
import { ModalContext } from '@/components/Modals/Modal/config';

import { ContractItemAnimationWrapper } from '../ContractItemAnimationWrapper/ContractItemAnimationWrapper';

interface AboutSpecContractItemProps {
  type: ContractType;
  userLevel: number;
  isUninitialized: boolean;
}

const AboutSpecContractItem: FC<AboutSpecContractItemProps> = ({
  type,
  userLevel,
  isUninitialized,
}) => {
  const { openModal } = useContext(ModalContext);
  const kind = type as SpecContractType;
  const reqLevel = specContractRequirenments[kind].level;

  const openAboutModal = (): void => {
    openModal({
      renderKind: specContractModalsName[kind],
      props: { status: 'forViewing', kind },
    });
  };

  return (
    userLevel < reqLevel && (
      <ContractItemAnimationWrapper isUninitialized={isUninitialized}>
        <SpecContractItem
          kind={kind}
          status="forViewing"
          requairedLevel={reqLevel}
          onClick={openAboutModal}
          timeLeft={null}
          contractTimerExtensionDuration={null}
        />
      </ContractItemAnimationWrapper>
    )
  );
};

export { AboutSpecContractItem };
